class CroReviewsCap extends HTMLElement {
  #list = null;
  #button = null;
  #observer = null;

  connectedCallback() {
    if (this.#attach()) return;
    this.#observer = new MutationObserver(() => this.#attach() && this.#observer.disconnect());
    this.#observer.observe(document.body, { childList: true, subtree: true });
  }

  disconnectedCallback() {
    this.#observer?.disconnect();
    this.#list?.removeEventListener('focusin', this.#onFocus);
    this.#button?.remove();
  }

  #attach() {
    const list = document.getElementById('bv_review_maincontainer');
    if (!list || list.dataset.croCap) return Boolean(list);
    this.#list = list;
    list.classList.add(...this.dataset.listClass.split(' '));
    list.dataset.croCap = 'collapsed';

    const button = document.createElement('button');
    button.type = 'button';
    button.className = this.dataset.buttonClass;
    button.setAttribute('aria-controls', 'bv_review_maincontainer');
    button.addEventListener('click', () => this.#set(list.dataset.croCap === 'collapsed', true));
    list.after(button);
    this.#button = button;
    list.addEventListener('focusin', this.#onFocus);

    new ResizeObserver(() => this.#syncNeed()).observe(list);
    this.#set(false);
    return true;
  }

  #onFocus = (event) => {
    if (this.#list.dataset.croCap !== 'collapsed') return;
    const capBottom = this.#list.getBoundingClientRect().top + this.#list.clientHeight;
    if (event.target.getBoundingClientRect().bottom > capBottom) this.#set(true);
  };

  #syncNeed() {
    const collapsed = this.#list.dataset.croCap === 'collapsed';
    const overflowing = this.#list.scrollHeight > this.#list.clientHeight + 1;
    this.#button.hidden = collapsed && !overflowing;
    this.#list.toggleAttribute('data-cro-cap-overflow', collapsed && overflowing);
  }

  #set(expanded, fromUser = false) {
    this.#list.dataset.croCap = expanded ? 'expanded' : 'collapsed';
    this.#button.setAttribute('aria-expanded', String(expanded));
    this.#button.textContent = expanded ? this.dataset.lessLabel : this.dataset.moreLabel;
    if (!expanded && fromUser) this.#list.scrollIntoView({ block: 'nearest' });
    this.#syncNeed();
  }
}

if (!customElements.get('cro-reviews-cap')) customElements.define('cro-reviews-cap', CroReviewsCap);
